import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
import { Content_ProviderCommonFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderCommonFragment.generated'
import { ContentPreviewMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentPreviewMediaFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
export type YiSeries_EpisodeDetailsContentFragmentFragment = {
  __typename?: 'Content'
  title?: string | null
  id?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  seasonNumber?: number | null
  episodeNumber?: number | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type YiSeries_EpisodeContentFragmentFragment = {
  __typename?: 'ContentReference'
  id?: string | null
  sortKey?: number | null
  contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
  contentTo?: Array<{
    __typename?: 'Content'
    title?: string | null
    id?: string | null
    contentType?: string | null
    contentId?: number | null
    published?: boolean | null
    seasonNumber?: number | null
    episodeNumber?: number | null
    providerMetadata?: {
      __typename?: 'ContentProvider'
      metadata?: any | null
      contentId?: string | null
    } | null
  } | null> | null
}

export type YiSeries_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  description?: string | null
  descriptionFormat?: string | null
  productType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  contentPolicyPolicyId?: number | null
  previewMediaId?: string | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: Types.ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiSeriesEpisodes?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      title?: string | null
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      seasonNumber?: number | null
      episodeNumber?: number | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  previewMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiSeries_EpisodeDetailsContentFragmentFragmentDoc = gql`
  fragment YISeries_EpisodeDetailsContentFragment on Content {
    title
    id
    contentType
    contentId
    published
    seasonNumber
    episodeNumber
    ...Content_ProviderMetadataFragment
  }
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
export const YiSeries_EpisodeContentFragmentFragmentDoc = gql`
  fragment YISeries_EpisodeContentFragment on ContentReference {
    id
    sortKey
    contentReferenceType {
      type
    }
    contentTo {
      ...YISeries_EpisodeDetailsContentFragment
    }
  }
  ${YiSeries_EpisodeDetailsContentFragmentFragmentDoc}
`
export const YiSeries_ContentFragmentFragmentDoc = gql`
  fragment YISeries_ContentFragment on Content {
    id
    contentId
    contentType
    published
    publishedAtDate
    createdAt
    updatedAt
    title
    path
    shortDescription
    shortDescriptionFormat
    description
    descriptionFormat
    productType
    language
    primaryLanguage
    ...ContentPreviewMediaFragment
    contentProvider {
      provider
      providerKey
      ...Content_ProviderCommonFragment
    }
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiSeriesEpisodes: contentReferencesFrom(types: ["yi-series-episode"]) {
      ...YISeries_EpisodeContentFragment
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentPreviewMediaFragmentFragmentDoc}
  ${Content_ProviderCommonFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${YiSeries_EpisodeContentFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
